import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useStyles } from './error-modal.styles';
import { v2025PP16783 } from '../../../../../constants/veeva';
import { Modal } from '../../../../common';
import { ErrorModalProps } from './error-modal.models';
import { Button } from '../../../../common/button-new';

export const ErrorModal = ({
  title, text, firstButton, secondButton, onFirstButtonClick, onSecondButtonClick, onClose, firstButtonUrl, ...props
}: ErrorModalProps): JSX.Element => {
  const classes = useStyles();

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  const handleFirstButtonClick = () => {
    if (!firstButtonUrl) {
      if (onFirstButtonClick) {
        onFirstButtonClick();
      } else {
        handleClose();
      }
    }
  };

  return (
    <Modal
      {...props}
      propsPaperStyles={classes.paperStyles}
      propsContentStyles={classes.contentStyles}
      onClose={onClose}
      veevaNumber={v2025PP16783}
      content={(
        <>
          <h2 className={classes.title}>
            <FormattedMessage id={title} values={{ noBreak: <>&nbsp;</> }} />
          </h2>
          <p className={classes.text}>
            <FormattedMessage id={text} values={{ noBreak: <>&nbsp;</> }} />
          </p>
          <div className={classes.actions}>
            <Button to={firstButtonUrl} style="dark" onClick={handleFirstButtonClick}>
              <FormattedMessage id={firstButton} />
            </Button>
            {secondButton && (
              <Button style="outlined" onClick={onSecondButtonClick || handleClose}>
                <FormattedMessage id={secondButton} />
              </Button>
            )}
          </div>
        </>
      )}
    >
    </Modal>
  );
};
